function fc_tabs_slider(id){
if($(id).hasClass('slick-initialized')) {
        //$(id).slick('unslick');
}else{

$(id).slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ],
  prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='42' height='42' viewBox='0 0 62 62' fill='none' xmlns='http://www.w3.org/2000/svg'> <g filter='url(#filter0_d_176_1493)'> <circle cx='31' cy='30' r='25' fill='white'/> <circle cx='31' cy='30' r='24.5' stroke='#EFEFEF'/> </g> <path d='M28.0661 30.0002L35.6694 22.3967C35.9889 22.0772 35.9889 21.5592 35.6694 21.2396C35.3499 20.9201 34.8318 20.9201 34.5123 21.2397L26.3305 29.4217C26.177 29.5751 26.0908 29.7832 26.0908 30.0002C26.0908 30.2172 26.1771 30.4253 26.3305 30.5787L34.5123 38.7603C34.672 38.9201 34.8814 39 35.0908 39C35.3002 39 35.5096 38.9201 35.6694 38.7603C35.9889 38.4408 35.9889 37.9228 35.6694 37.6032L28.0661 30.0002Z' fill='black'/> <defs> <filter id='filter0_d_176_1493' x='0' y='0' width='62' height='62' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'> <feFlood flood-opacity='0' result='BackgroundImageFix'/> <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/> <feOffset dy='1'/> <feGaussianBlur stdDeviation='3'/> <feComposite in2='hardAlpha' operator='out'/> <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/> <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_176_1493'/> <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_176_1493' result='shape'/> </filter> </defs> </svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='42' height='42' viewBox='0 0 62 62' fill='none'><g filter='url(#filter0_d_176_1494)'><circle cx='25' cy='25' r='25' transform='matrix(-1 0 0 1 56 5)' fill='white'/><circle cx='25' cy='25' r='24.5' transform='matrix(-1 0 0 1 56 5)' stroke='#EFEFEF'/></g><path d='M33.9339 30.0002L26.3306 22.3967C26.0111 22.0772 26.0111 21.5592 26.3306 21.2396C26.6501 20.9201 27.1682 20.9201 27.4877 21.2397L35.6695 29.4217C35.823 29.5751 35.9092 29.7832 35.9092 30.0002C35.9092 30.2172 35.8229 30.4253 35.6695 30.5787L27.4877 38.7603C27.328 38.9201 27.1186 39 26.9092 39C26.6998 39 26.4904 38.9201 26.3306 38.7603C26.0111 38.4408 26.0111 37.9228 26.3306 37.6032L33.9339 30.0002Z' fill='black'/><defs><filter id='filter0_d_176_1494' x='0' y='0' width='62' height='62' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset dy='1'/><feGaussianBlur stdDeviation='3'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_176_1494'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_176_1494' result='shape'/></filter></defs></svg></button>"

});
}
}
    
 

$(function(){
  fc_tabs_slider('.featured-coll-tabs-slider .tab-contents .tab-content:nth-child(1) .product-grid');
  $('.featured-coll-tabs-slider .tab-button').click(function(){
         var id=$(this).attr('data-tab');
         setTimeout(() => {
                fc_tabs_slider('.featured-coll-tabs-slider #'+id+' .product-grid');
            }, 100);
        
  });

$('.featured-collection-slider .product-grid').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ],
  prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='42' height='42' viewBox='0 0 62 62' fill='none' xmlns='http://www.w3.org/2000/svg'> <g filter='url(#filter0_d_176_1493)'> <circle cx='31' cy='30' r='25' fill='white'/> <circle cx='31' cy='30' r='24.5' stroke='#EFEFEF'/> </g> <path d='M28.0661 30.0002L35.6694 22.3967C35.9889 22.0772 35.9889 21.5592 35.6694 21.2396C35.3499 20.9201 34.8318 20.9201 34.5123 21.2397L26.3305 29.4217C26.177 29.5751 26.0908 29.7832 26.0908 30.0002C26.0908 30.2172 26.1771 30.4253 26.3305 30.5787L34.5123 38.7603C34.672 38.9201 34.8814 39 35.0908 39C35.3002 39 35.5096 38.9201 35.6694 38.7603C35.9889 38.4408 35.9889 37.9228 35.6694 37.6032L28.0661 30.0002Z' fill='black'/> <defs> <filter id='filter0_d_176_1493' x='0' y='0' width='62' height='62' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'> <feFlood flood-opacity='0' result='BackgroundImageFix'/> <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/> <feOffset dy='1'/> <feGaussianBlur stdDeviation='3'/> <feComposite in2='hardAlpha' operator='out'/> <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/> <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_176_1493'/> <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_176_1493' result='shape'/> </filter> </defs> </svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='42' height='42' viewBox='0 0 62 62' fill='none'><g filter='url(#filter0_d_176_1494)'><circle cx='25' cy='25' r='25' transform='matrix(-1 0 0 1 56 5)' fill='white'/><circle cx='25' cy='25' r='24.5' transform='matrix(-1 0 0 1 56 5)' stroke='#EFEFEF'/></g><path d='M33.9339 30.0002L26.3306 22.3967C26.0111 22.0772 26.0111 21.5592 26.3306 21.2396C26.6501 20.9201 27.1682 20.9201 27.4877 21.2397L35.6695 29.4217C35.823 29.5751 35.9092 29.7832 35.9092 30.0002C35.9092 30.2172 35.8229 30.4253 35.6695 30.5787L27.4877 38.7603C27.328 38.9201 27.1186 39 26.9092 39C26.6998 39 26.4904 38.9201 26.3306 38.7603C26.0111 38.4408 26.0111 37.9228 26.3306 37.6032L33.9339 30.0002Z' fill='black'/><defs><filter id='filter0_d_176_1494' x='0' y='0' width='62' height='62' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset dy='1'/><feGaussianBlur stdDeviation='3'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_176_1494'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_176_1494' result='shape'/></filter></defs></svg></button>"

});
  
});

    



equalheight = function(container){

  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {
    $el = $(this);
    $($el).height('auto')
    var topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}
$(document).ready(function(){
    equalheight('.product-grid .grid__item');
  $(window).on('resize', function(){
  equalheight('.product-grid .grid__item');
});
});

 let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


    function text_slider(){
        if($(window).width() <= 640) {
        $('.home-text-slider .multicolumn-list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows:false,
            autoplay: true,
            autoplaySpeed: 1500,
            infinite: true,
        });
    }else{
          if($('.home-text-slider .multicolumn-list').hasClass('slick-initialized')) {
        $('.home-text-slider .multicolumn-list').slick('unslick');
      }
      
    }
  }
$(function(){
  text_slider();
  
  $(window).resize(function () {
    text_slider();
  });
});